import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const emailNotification = () => import(/* webpackChunkName: "emailNotification" */ '../components/emailNotification');
const orderNew = () => import(/* webpackChunkName: "orderNew" */ '../components/orderManage/new');
const orderSearch = () => import(/* webpackChunkName: "orderSearch" */ '../components/orderManage/search');
const report = () => import(/* webpackChunkName: "report" */ '../components/report');
const login = r => require.ensure([], () => r(require('../components/login.vue')), 'login');
const plLearderManage = r => require.ensure([], () => r(require('../components/plLearderManage.vue')), 'plLearderManage');
const organization = r => require.ensure([], () => r(require('../components/organization.vue')), 'organization');
const activation = r => require.ensure([], () => r(require('../components/activation.vue')), 'activation');
const plManage = r => require.ensure([], () => r(require('../components/plManage.vue')), 'plManage');
const forgetPassword = r => require.ensure([], () => r(require('../components/forgetPassword.vue')), 'forgetPassword');
const profile = r => require.ensure([], () => r(require('../components/profile.vue')), 'profile');
const supplierManage = r => require.ensure([], () => r(require('../components/supplierManage.vue')), 'supplierManage');
const fgProfile = r => require.ensure([], () => r(require('../components/fgProfile.vue')), 'fgProfile');
const departmentManage = r => require.ensure([], () => r(require('../components/departmentManage.vue')), 'departmentManage');
const orderDraft = r => require.ensure([], () => r(require('../components/orderManage/draft.vue')), 'orderDraft');
const orderInProcess = r => require.ensure([], () => r(require('../components/orderManage/inProcess.vue')), 'orderInProcess');
const orderEdit = r => require.ensure([], () => r(require('../components/orderManage/edit.vue')), 'orderEdit');
const orderView = r => require.ensure([], () => r(require('../components/orderManage/view.vue')), 'orderView');
const orderClosed = () => import(/* webpackChunkName: "orderClosed" */ '../components/orderManage/closed');
const orderPending = r => require.ensure([], () => r(require('../components/orderManage/pending.vue')), 'orderPending');
const orderCancelled = r => require.ensure([], () => r(require('../components/orderManage/cancelled.vue')), 'orderCancelled');
const orderPotentialDelay = r => require.ensure([], () => r(require('../components/orderManage/potentialDelay.vue')), 'orderPotentialDelay');
const register = r => require.ensure([], () => r(require('../components/register.vue')), 'register');
const emailNotifier = r => require.ensure([], () => r(require('../components/emailNotifier.vue')), 'emailNotifier');
const orderProcessed = r => require.ensure([], () => r(require('../components/orderManage/processed.vue')), 'orderProcessed');
const orderCancelRequest = r => require.ensure([], () => r(require('../components/orderManage/cancelRequest.vue')), 'orderCancelRequest');
const process = r => require.ensure([], () => r(require('../components/process.vue')), 'process');
const invoice = r => require.ensure([], () => r(require('../components/orderManage/invoice')), 'invoice');
const complaintRequest = () => import(/* webpackChunkName: "complaintRequest" */ '../components/orderManage/complaintRequest');



const root = Vue.component('root', {
  template: '<router-view></router-view>'
});

export default new Router({
  routes: [{
    path: '/login',
    name: 'Login',
    component: login,
    meta: {
      hidden: true
    }
  }, {
    path: '/register',
    name: 'Register',
    component: register,
    meta: {
      hidden: true
    }
  }, {
    path: '/activation',
    name: 'Activation',
    component: activation,
    meta: {
      hidden: true
    }
  }, {
    path: '/forgetPassword',
    name: 'Forget Password',
    component: forgetPassword,
    meta: {
      hidden: true
    }
  }, {
    path: '/orderManage/edit',
    name: 'Edit',
    component: orderEdit,
  }, {
    path: '/orderManage/view',
    name: 'View',
    component: orderView
  }, {
    path: '/',
    component: root,
    meta: {
      requireAuth: true
    },
    children: [{
      path: 'orderManage',
      name: 'Order Manage',
      component: root,
      iconClass: 'wpforms',
      meta: {
        role: [4, 5, 6, 7]
      },
      children: [{
        path: 'search',
        name: 'All Orders',
        component: orderSearch,
        meta: {
          role: [4, 5, 6, 7]
        }
      }, {
        path: 'new',
        name: 'New',
        component: orderNew,
        meta: {
          role: [4, 5, 6]
        },
      }, {
        path: 'draft',
        name: 'Draft',
        component: orderDraft,
        meta: {
          role: [4, 5, 6]
        }
      }, {
        path: 'In-Process',
        name: 'Untreated',
        component: orderInProcess,
        meta: {
          role: [4, 5, 6, 7]
        }
      }, {
        path: 'processed',
        name: 'Processed',
        component: orderProcessed,
        meta: {
          role: [4, 5, 6, 7]
        }
      }, {
        path: 'cancel-request',
        name: 'Cancel Request',
        component: orderCancelRequest,
        meta: {
          role: [4, 5, 6, 7]
        }
      }, {
        path: 'pending',
        name: 'Pending',
        component: orderPending,
        meta: {
          role: [4, 5, 6, 7]
        }
      }, {
        path: 'Potential-Delay',
        name: 'Potential Delay',
        component: orderPotentialDelay,
        meta: {
          role: [4, 5, 6, 7]
        }
      }, {
        path: 'closed',
        name: 'Closed',
        component: orderClosed,
        meta: {
          role: [4, 5, 6, 7]
        }
      }, {
        path: 'cancelled',
        name: 'Cancelled',
        component: orderCancelled,
        meta: {
          role: [4, 5, 6, 7]
        }
      }, {
        path: 'complaintRequest',
        name: 'Complaint Request',
        component: complaintRequest,
        meta: {
          role: [7]
        }
      }, {
        path: 'invoice',
        name: 'Invoice',
        component: invoice,
        meta: {
          role: [5, 7]
        }
      }]
    }, {
      path: 'PL-Learder-Manage',
      name: 'PL Manage',
      component: plLearderManage,
      iconClass: 'user-secret',
      meta: {
        role: [1]
      }
    }, {
      path: 'organization',
      name: 'Organization',
      component: organization,
      iconClass: 'sitemap',
      meta: {
        role: [1]
      }
    }, {
      path: 'PL-Manage',
      name: 'PL Manage ',
      component: plManage,
      iconClass: 'user-secret',
      meta: {
        role: [2, 3]
      }
    }, {
      path: 'supplierManage',
      name: 'Supplier Manage',
      component: supplierManage,
      iconClass: 'archive',
      meta: {
        role: [4, 5]
      }
    }, {
      path: 'supplierManage/cpt',
      name: 'CPT Supplier',
      component: supplierManage,
      iconClass: 'archive',
      meta: {
        role: [1]
      }
    }, {
      path: 'supplierManage/fg',
      name: 'FG Supplier',
      component: supplierManage,
      iconClass: 'archive',
      meta: {
        role: [1]
      }
    }, {
      path: 'report',
      name: 'Report',
      component: report,
      iconClass: 'bar-chart',
      meta: {
        role: [4, 5, 7]
      }
    }, {
      path: 'profile',
      name: 'Profile',
      component: profile,
      iconClass: 'user-o',
      meta: {
        role: [2, 3, 4, 5]
      }
    }, {
      path: 'FG-Profile',
      name: 'Profile ',
      component: fgProfile,
      iconClass: 'user-o',
      meta: {
        role: [6]
      }
    }, {
      path: 'email-notifier',
      name: 'Email Notifier',
      component: emailNotifier,
      iconClass: 'cog',
      meta: {
        role: [4, 5, 6, 7]
      }
    }, {
      path: 'departmentManage',
      name: 'Department Manage',
      component: departmentManage,
      iconClass: 'archive',
      meta: {
        role: [7]
      }
    }, {
      path: 'process',
      name: 'Process',
      component: process,
      iconClass: 'gear',
      meta: {
        role: [1]
      }
    }, {
      path: 'emailNotification',
      name: 'Email Notification',
      component: emailNotification,
      iconClass: 'envelope',
      meta: {
        role: [4, 5, 6]
      }
    }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js